<template>
	<div>
		<RequisitionDialog
			:onClose="handleClose"
			requisitionType="new_offer"
			:requisitionId="requisitionId"
			:actionType="actionType"
		></RequisitionDialog>
	</div>
</template>

<script>
import RequisitionDialog from '@/components/shared/requisitionDialog/RequisitionDialog';
import { mapState } from 'vuex';

export default {
	name: 'OfferRequisition',
	components: {
		RequisitionDialog,
	},
	computed: {
		...mapState({
			currentLang: state => state.currentUser.lang,
		}),
	},
	data() {
		const { requisitionId } = this.$route.params;
		return {
			requisitionId,
			actionType: requisitionId !== 'new' ? 'edit' : 'new',
		};
	},
	methods: {
		handleClose() {
			const { currentLang } = this;
			const { query } = this.$route;
			const { candidateId } = this.$route.params;

			if (candidateId) {
				this.$router.push({
					path: `/${currentLang}/candidates/edit/${candidateId}`,
					query,
				});
			} else {
				this.$router.push({
					path: `/${currentLang}/candidates`,
					query,
				});
			}
		},
	},
};
</script>
